export default {
  computed: {
    userIsEnabled () {
      return this.user.enabled
    },

    userIsDisabled () {
      return !this.user.enabled
    },

    userIsAdmin () {
      return this.user.role === 'admin'
    },

    userIsManager () {
      return this.user.role === 'manager'
    },

    userIsGraduate () {
      return this.user.role === 'graduate'
    },

    userIsCoordinator () {
      return this.user.role === 'coordinator'
    }
  }
}
